<div class="logs-container">
  <div class="logs-header">
    <h2>Activity Logs</h2>
  </div>

  <div class="custom-table">
    <table>
      <thead>
        <tr>
          <th scope="col">NAME</th>
          <th scope="col">IP ADDRESS</th>
          <th scope="col">TIMESTAMP</th>
          <th scope="col">ACTION</th>
        </tr>
      </thead>
      <tbody *ngIf="!isLoading && logs.length > 0">
        <tr *ngFor="let log of logs">
          <td data-thead="NAME">
            <span class="log-name">{{ log.name | allLettersCapital }}</span>
          </td>
          <td data-thead="IP ADDRESS">
            <span class="log-ip">{{ log.ipAddress }}</span>
          </td>
          <td data-thead="TIMESTAMP">
            <span class="log-timestamp">{{ log.timestamp }}</span>
          </td>
          <td data-thead="ACTION">
            <span class="log-action">{{ log.action | allLettersCapital }}</span>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="isLoading">
        <tr *ngFor="let item of [1,2,3,4,5]">
          <td data-thead="NAME">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="IP ADDRESS">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="TIMESTAMP">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
          <td data-thead="ACTION">
            <ngx-skeleton-loader appearance="line"></ngx-skeleton-loader>
          </td>
        </tr>
      </tbody>
      <tbody *ngIf="!isLoading && logs.length === 0">
        <tr>
          <td colspan="4" class="no-data-cell">
            <div class="no-data-message">
              <p>No logs available</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
